
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Moment from "react-moment";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Spinner from "../component/Spinner";
import AlertErrorForm from "../component/AlertErrorForm";
import CarSelect from "../component/CarSelect";
import DateTimePicker from "react-datetime-picker";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export default function DanhSachDatXe() {
  let query = useQuery();
  const { user } = useSelector((state) => state.auth);
  const { carBookingStatus } = useSelector((state) => state.save);
  const [cars, setCars] = useState([])
  const [listDay, setListday] = useState([])
  const realToday = React.useMemo(() => new Date(), []);
  const today = query.get("date") ? new Date(query.get("date")) : new Date()
  const [showModal, setShowModal] = useState(false)
  const [refreshPage, setRefreshPage] = useState(false)
  const [detailActive, setDetailActive] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingCar, setLoadingCar] = useState(false)
  const weekdays = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', '7'];
  const [dateSelect, setDateSelect] = useState({ datestart: "", dateend: "" })
  const { notification } = useSelector((state) => state.save);
  const pickerRef = useRef(null);

  useEffect(function () {
    if (notification && notification.action && notification.action == 'car_booking' && notification.datebooking == moment(new Date(today)).format('YYYY-MM-DD')) {
      setRefreshPage(!refreshPage)
    }
  }, [notification])

  const Delete = (id) => {
    confirmAlert({
      title: 'Cảnh báo',
      message: 'Bạn có chắc chắn hủy lịch đặt xe này?',
      buttons: [{
        label: 'OK', onClick: () => {
          Axios.put(URL_LIST_ALL + 'car_booking/' + id, { status: 2 }, user.config).then(res => {
            if (res.data.status == "success") {
              setRefreshPage(!refreshPage)
            } else alert(res.data.message);
          }).catch(err => console.log(err));
        },
      }]
    });
  }

  useEffect(() => {
    const dates = [];
    for (let i = -3; i <= 1; i++) {
      const newDate = new Date(realToday);
      newDate.setDate(realToday.getDate() + i);
      const dayOfWeek = weekdays[newDate.getDay()];
      const day = `${newDate.getDate()}/${newDate.getMonth() + 1}`;
      const isActive =
        moment(newDate).format('YYYY-MM-DD') === moment(today).format('YYYY-MM-DD');

      dates.push({
        dayOfWeek,
        day,
        active: isActive ? 1 : 0,
        dateObject: newDate,
      });
    }
    setListday(dates)
  }, [])
  const getNextWorkingDay = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) { // Chủ nhật
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  useEffect(function () {
    setLoadingCar(true)
    Axios.get(URL_LIST_ALL + "cars?status=1&date=" + today.toISOString().split('T')[0], user.config)
      .then(async (res) => {
        setLoadingCar(false)
        if (res.data.status === "success") {
          let detail = res.data.data
          detail.forEach((item, i) => {
            detail[i].value = item.id
            detail[i].label = item.title
          });
          setCars(detail);
        } else console.log(res.data.message);
      })
      .catch((err) => { console.log(err); setLoadingCar(false) });
  }, [refreshPage])

  const isValidTimeFormat = (time) => {
    const regex = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
    return regex.test(time);
  }

  const formik = useFormik({
    initialValues: { title: '', timestart: null, datestart: null, timeend: null, dateend: null, driver: 0, car_id: 0, car_note: "", status: 1 },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().nullable().required('Nhập nội dung').max(150, "Độ dài không quá 150 ký tự"),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      let checker = 0
      values.dateend = moment(dateSelect.dateend).format('YYYY-MM-DD')

      if (!isValidTimeFormat(values.timestart) || !isValidTimeFormat(values.timeend)) {
        alert("Thời gian không đúng định dạng")
      } else {
        if (parseTimeToMinutes(values.timestart, values.datestart) <= parseTimeToMinutes(values.timeend, values.dateend)) {
          if (values.id) {
            if (getCurrentTimeAsMinutes() <= parseTimeToMinutes(values.timeend, values.dateend)) {
              checker = 1
            } else {
              alert("Giờ kết thúc không được nhỏ hơn giờ hiện tại")
            }
          } else {
            if (getCurrentTimeAsMinutes() <= parseTimeToMinutes(values.timestart, values.datestart)
              && getCurrentTimeAsMinutes() <= parseTimeToMinutes(values.timeend, values.dateend)) {
              checker = 1
            } else {
              alert("Giờ bắt đầu không được nhỏ hơn giờ hiện tại")
            }
          }
        } else {
          alert("Giờ bắt đầu không được lớn hơn giờ kết thúc")
        }

        if (checker == 1) {
          setLoading(true)
          if (values.id) {
            Axios.put(URL_LIST_ALL + 'car_booking/' + values.id, values, user.config).then(res => {
              if (res.data.status == "success") {
                setLoading(false)
                setShowModal(false)
                alert("Sửa lịch đặt xe thành công")
                setRefreshPage(!refreshPage)
              } else {
                alert(res.data.message)
              }
            }).catch(err => {
              console.log(err)
              setLoading(false)
            });
          } else {
            Axios.post(URL_LIST_ALL + 'car_booking', values, user.config).then(res => {
              setLoading(false)
              if (res.data.status == "success") {
                setShowModal(false)
                alert("Đặt xe thành công")
                setRefreshPage(!refreshPage)
              } else {
                alert(res.data.message)
              }
            }).catch(err => {
              console.log(err)
              setLoading(false)
            });
          }
          setSubmitting(false)
        }
      }
    },
  });


  const parseTimeToMinutes = (timeStr, dateStr) => {
    const dateTime = new Date(`${dateStr}T${timeStr}`);
    return Math.floor(dateTime.getTime() / 60000);
  }

  const getCurrentTimeAsMinutes = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
  };

  const handleDate = (name, value) => {
    let newDate = Object.assign({}, dateSelect)
    formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
    formik.setFieldTouched(name)
    newDate[name] = value
    if (!newDate.dateend || newDate.dateend == '') {
      newDate.dateend = newDate.datestart
    }
    if (newDate.datestart.getTime() > newDate.dateend.getTime()) {
      newDate.dateend = newDate.datestart
    }
    setDateSelect(newDate)
  };

  const showEditBooking = (detail) => {
    let datestart = detail.datestart
    let dateend = detail.dateend
    formik.setFieldValue('title', detail.title)
    formik.setFieldValue('id', detail.id)
    formik.setFieldValue('car_id', detail.car_id)
    formik.setFieldValue('timestart', moment(new Date(datestart * 1000)).format('HH:mm'))
    formik.setFieldValue('timeend', moment(new Date(dateend * 1000)).format('HH:mm'))
    formik.setFieldValue('datestart', moment(new Date(datestart * 1000)).format('YYYY-MM-DD'))
    formik.setFieldValue('dateend', moment(new Date(dateend * 1000)).format('YYYY-MM-DD'))
    formik.setFieldValue('car_note', detail.car_note)
    setDateSelect({ datestart: datestart * 1000, dateend: dateend * 1000 })
    setShowModal(true)
  }
  const actionBooking = (item) => {
    setShowModal(!showModal);
    setDetailActive(item);
    formik.resetForm();
    formik.setFieldValue('car_id', item.id)
    formik.setFieldValue('aprover_id', item.aprover_id)
    setDateSelect({ datestart: today, dateend: today })
    formik.setFieldValue('datestart', moment(today).format('YYYY-MM-DD'))
    formik.setFieldValue('dateend', moment(today).format('YYYY-MM-DD'))
  }

  const checkStatus = (data, id) => {
    if (data && data[id]) {
      return <span className="status busy"><i className=""></i></span>
    }
    return <span className="status"><i></i></span>
  }
  const checkStatusItem = (data, car_id, id) => {
    if (data && data[car_id] && data[car_id] == id) {
      return <span className="status busy"><i></i></span>
    }
    return ''
  }

  // Thay vì backDate, bạn nên khai báo:
  const tomorrow = getNextWorkingDay(realToday)

  return (<AkkhorLayout idrole="dashboard">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Quản lý xe
        </li>
      </ul>
    </div>
    <div className="w-100 d-flex justify-content-center">
      <div className="listday">
        {listDay ? listDay.map((item, i) => {
          return <a href={"/dat-xe?date=" + moment(new Date(item.dateObject)).format('YYYY-MM-DD')}
            className={"item-day rounded border shadow-sm mb-2 " + (item.active ? "bg-warning" : (moment(new Date(item.dateObject)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD') ? " bg-info" : ""))} key={i}>
            <span>{item.dayOfWeek} <br /> {item.day}</span>
          </a>
        }) : ''}
        <button type="button" className="item-day rounded border shadow-sm" onClick={() => pickerRef.current.openCalendar()}><i className="fas fa-calendar-alt"></i></button>
        <DateTimePicker onChange={(value) => { window.location.href = "/dat-xe?date=" + moment(new Date(value)).format('YYYY-MM-DD') }} value={today} format="dd-MM-y" className="air-datepicker" disableClock={true}
          hourPlaceholder="giờ" minutePlaceholder="phút" secondPlaceholder="giây" yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" ref={pickerRef}
          maxDate={new Date(new Date().setDate(new Date().getDate() + 1))}></DateTimePicker>
      </div>
    </div>

    {loadingCar ? <div className="w-100 d-flex justify-content-center mt-3 mb-3"><Spinner /></div> : null}

    <div className="row listcar mt-5">
      {cars.map((item, i) => {
        return <div className="col-12 col-sm-4 car-item" key={i}>
          <div className="car-wrapper bg-white rounded border shadow-sm">
            <h5 className="w-100 text-center pt-2 pb-2">
              {item.title} {item.car_id}
              {carBookingStatus && carBookingStatus.data ? checkStatus(carBookingStatus.data, item.id) : (item.carBookingStatus && Object.keys(item.carBookingStatus).length > 0 ? checkStatus(item.carBookingStatus, item.id) : <span className="status"><i></i></span>)}
            </h5>
            <div className="timeline">
              {item.listtime && item.listtime.map(function (booking, j) {
                let time_start = new Date(booking.datestart * 1000);
                let time_end = new Date(booking.dateend * 1000);
                let datefomatstart = moment(time_start).format('DD/MM/YYYY')
                let datefomatend = moment(time_end).format('DD/MM/YYYY')

                return <div className="item-booking border-bottom pl-2 pr-2" key={j}>
                  <div className="row">
                    <div className="col-5 left pt-2 pb-2">
                      {datefomatstart == datefomatend ?
                        <div className="insite w-100">
                          <Moment format="HH:mm">{time_start}</Moment> <span className="fas fa-arrow-right text-danger"></span> <Moment format="HH:mm">{time_end}</Moment> <br />ngày {datefomatstart}
                        </div>
                        :
                        <div className="insite w-100">
                          <div className="w-100 d-flex justify-content-center">
                            <Moment format="HH:mm D/M/YYYY">{time_start}</Moment>
                          </div>
                          <div className="w-100 d-flex justify-content-center">
                            <span className="far fa-clock text-info"></span>
                            <span className="far fa-arrow-alt-circle-down text-danger"></span>
                          </div>
                          <div className="w-100 d-flex justify-content-center">
                            <Moment format="HH:mm D/M/YYYY">{time_end}</Moment>
                          </div>
                        </div>
                      }

                      {(user.data.id == item.aprover_id || user.data.id == booking.user_id) && (time_start >= new Date()) ?
                        <div className="action justify-content-center mt-2">
                          {user.data.id == item.aprover_id ?
                            <button className="btn btn-sm btn-warning text-warning" type="button" title="Sửa" onClick={() => {
                              showEditBooking(booking);
                              setDetailActive(item)
                            }}>
                              <i className="far fa-edit"></i>
                            </button>
                            : ''
                          }
                          {(time_start >= new Date()) ?
                            <button className="btn btn-sm btn-danger text-danger ml-2" type="button" title="Xóa" onClick={() => Delete(booking.id)}>
                              <i className="far fa-trash-alt"></i>
                            </button>
                            : ''
                          }

                        </div>
                        : ''
                      }
                    </div>
                    <div className="col-7 right border-left pt-2 pb-2">
                      <div className="w-100 mb-2">
                        <i className="mr-2 fas fa-car-alt text-success"></i>
                        {booking.title}

                      </div>
                      <div className="w-100 mb-2 booker-name position-relative">
                        <div className="cursor-pointer"><i className="fas fa-user-tag text-success"></i> {booking.booker_name} <i className="far fa-eye text-warning"></i></div>
                        <div className="booker_info">
                          <div className="wrapper border shadow-sm">
                            <p>Họ tên: <strong>{booking.booker_name}</strong></p>
                            <p>Phòng ban: <strong>{booking.phongban}</strong></p>
                            <p>Công ty: <strong>{booking.congty}</strong></p>
                            <p>Email: <strong>{booking.booker_mail}</strong></p>
                          </div>
                        </div>
                      </div>
                      <div className="w-100"><i className="fas fa-chalkboard-teacher text-success"></i> {booking.driver == 1 ? "Có lái xe" : "Không lái xe"}</div>
                      {booking.car_note ? <div className="w-100 mb-2"><i className="fas fa-angle-right text-danger"></i> <small>Ghi chú: {booking.car_note}</small></div> : ''}
                      {carBookingStatus && carBookingStatus.data ? checkStatusItem(carBookingStatus.data, item.id, booking.id) : checkStatusItem(item.carBookingStatus, item.id, booking.id)}
                    </div>
                  </div>
                </div>
              })}
            </div>
            <div className="w-100 d-flex justify-content-center pt-2 pb-2">
              <button type="button" className="btn btn-sm btn-success pl-5 pr-5" onClick={() => { actionBooking(item) }}>Đặt xe</button>
            </div>
          </div>
        </div>
      })}
    </div>

    <Modal show={showModal} onHide={() => setShowModal(false)} animation={true} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Đặt xe: {detailActive ? <strong>{detailActive.title + ' ' + detailActive.car_id}</strong> : null}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12 form-group">
              <label>Nội dung đặt xe <span className="text-danger">*</span></label>
              <input type="text" placeholder="VD: Đặt xe đi Hạ Long" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
              <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
            </div>
            <div className="col-12 form-group">
              <label>Chọn xe</label>
              <CarSelect onChange={(e) => formik.setFieldValue('car_id', e.value)} defaultvalue={detailActive ? detailActive : null} />
            </div>
            <div className="col-sm-6 col-12 form-group">
              <label>Giờ bắt đầu: <span className="text-danger">*</span></label>
              <input type="text" placeholder="VD: 10:00" className="form-control height32" {...formik.getFieldProps("timestart")} />
            </div>

            <div className="col-sm-6 col-12 form-group">
              <label>Giờ kết thúc: <span className="text-danger">*</span></label>
              <input type="text" placeholder="VD: 17:50" className="form-control height32" {...formik.getFieldProps("timeend")} />
            </div>
            <div className="col-12 form-group">
              <label>Ngày sử dụng: <span className="text-danger">*</span></label>
              <DateTimePicker
                onChange={(value) => { if(value)handleDate('datestart', value) }}
                value={dateSelect.datestart ? new Date(dateSelect.datestart) : tomorrow}
                format="dd-MM-y"
                className="form-control height32 air-datepicker"
                disableClock={true}
                yearPlaceholder="Năm"
                monthPlaceholder="Tháng"
                dayPlaceholder="Ngày"
                minDate={tomorrow}
                maxDate={tomorrow}
              />
              <AlertErrorForm formik={formik} name="datestart"></AlertErrorForm>
            </div>
            {/* <div className="col-sm-7 col-12 form-group">
              <label>Ngày kết thúc: <span className="text-danger">*</span></label>
              <DateTimePicker onChange={(value) => { handleDate('dateend', value) }} value={dateSelect.dateend ? new Date(dateSelect.dateend) : ''} format="dd-MM-y" className="form-control height32 air-datepicker" disableClock={true}
                yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" minDate={backDate}></DateTimePicker>
              <AlertErrorForm formik={formik} name="dateend"></AlertErrorForm>
            </div> */}


            <div className="col-12 form-group">
              <label>Ghi chú: </label>
              <textarea placeholder="Ghi chú" className="form-control" {...formik.getFieldProps("car_note")} style={{ minHeight: "95px" }}></textarea>
            </div>
            {detailActive && detailActive.id == 1 &&
              <div className="col-12 form-group car-driver">
                <div className="form-check">
                  <input type="radio" className="form-check-input" id="radioDrive1" value="0" checked={formik.values['driver'] == "0"} onChange={(e) => formik.setFieldValue('driver', e.target.value)} />
                  <label className="form-check-label" htmlFor="radioDrive1">
                    Không cần tài xế
                  </label>
                </div>
                <div className="form-check">
                  <input type="radio" className="form-check-input" id="radioDrive2" value="1" checked={formik.values['driver'] == "1"} onChange={(e) => formik.setFieldValue('driver', e.target.value)} />
                  <label className="form-check-label" htmlFor="radioDrive2">
                    Cần tài xế
                  </label>
                </div>
              </div>
            }

            <div className="col-12 form-group mt-3 d-flex justify-content-center">
              <button type="button" onClick={() => formik.submitForm()} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu</>}</button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  </AkkhorLayout>);
}
